import React, { useCallback, useEffect, useState } from 'react';
import { fetchTotalCatalogs, fetchTotalDeviceGroups, fetchTotalDevices, fetchTotalDeviceModels, fetchTotalUsers, totalDevicesByDeviceModel } from '../commonApi';
import { toast } from 'react-toastify';
import DashboardChart from '../components/DashboardChart';
import DashboardCard from '../components/DashboardCard';
import "../assets/css/Dashboard.css"
import "../assets/css/Loader.css";

const Dashboard = () => {

  const [data, setData] = useState({
      chartData: [],
      cardData: [],
    });
  const [loading, setLoading] = useState(true);

  const chartType = "bar";
  const chartTitle = "Total Devices by Models";
  const chartLabel = "Device Model";
  const [chartBackgroundColor, setChartBackgroundColor] =useState();
  const [chartBorderColor, setChartBorderColor] = useState();
  const chartBorderWidth = 2;

  const generateRandomColors = (size) => {
    const colors = {
      background: [],
      border: []
    };
  
    for (let i = 0; i < size; i++) {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
  
      colors.background.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
  
      colors.border.push(`rgba(${r}, ${g}, ${b}, 1)`);
    }

    setChartBackgroundColor(colors.background);
    setChartBorderColor(colors.border);
  };




  const fetchCardData = async () => {
    setLoading(true);
    const [totalDevices, totalDeviceGroups, totalUsers, totalDeviceModels, totalCatalogs] = await Promise.all([
      fetchTotalDevices(),
      fetchTotalDeviceGroups(),
      fetchTotalUsers(),
      fetchTotalDeviceModels(),
      fetchTotalCatalogs()
    ]);

    const cardDataMap = new Map();
    const handleData = (data, fallback) => {
      return Object.entries(data || fallback).forEach(([key, value]) => {
        cardDataMap.set(key, value);
      });
    };

    handleData(totalDevices?.data?.data?.totalDevices, totalDevices);
    handleData(totalDeviceGroups?.data?.data?.totalDeviceGroups, totalDeviceGroups);
    handleData(totalUsers?.data?.totalUsers, totalUsers);
    handleData(totalDeviceModels?.data?.data?.totalDeviceModels,totalDeviceModels);
    handleData(totalCatalogs?.data?.totalCatalogs, totalCatalogs);

    const cardDataFormatted = Array.from(cardDataMap.entries()).map(([key, value]) => ({
      id: key,
      title: key,
      content: value,
    }));
    
    return cardDataFormatted;
  }
 

  const fetchData = useCallback(async () => {
      try {

        const [cardData, response] = await Promise.all([fetchCardData(), totalDevicesByDeviceModel()]);
        let chartDataFormatted = [];
        if(response?.data) {
          const deviceCountsMap = response.data.deviceCounts;
          generateRandomColors(Object.keys(deviceCountsMap).length);
          chartDataFormatted = Object.keys(deviceCountsMap).map(deviceType => ({
            label: deviceType,
            data: deviceCountsMap[deviceType],
          }));
        } else {
          chartDataFormatted = [{
            label: "No Data",
          }];
        }
  
        setData({
          chartData: chartDataFormatted,
          cardData: cardData,
        });
  
      } catch (error) {
        toast.error("Error fetching details!");
      } finally {
        setLoading(false);
      }
    }, []);

    useEffect(() => {
      fetchData();
    }, [fetchData]);        
  
  return (
    <div className='custom_tab_wrapper' style={{height: "97%"}}>
      <div className='dashboard'>
        <div className='dashboard-left-card'>
          <div>
          {
            loading ? (
              <span class="loader" />
            ) : (
              data.chartData[0]?.label === "No Data" ? (
                <div className='no-data-message'>{data.chartData[0]?.label}</div>
              ) : (
                <>
                
                <DashboardChart type={chartType}  textTitle={""} chartData={data.chartData} label={chartLabel} backgroundColor={chartBackgroundColor} borderColor={chartBorderColor} borderWidth={chartBorderWidth} height="inherit" width="inherit" />
                
                </>

              )
            )
          }
          </div>
          <div className='chart-title' >
            <div className='chart-legend-label' >Device Model</div>
            <span>{chartTitle}</span>
          </div>
        
        </div>
        <div className='dashboard-right-card'>
        {data.cardData.length === 0 ? (
            Array(5).fill(0).map((_, idx) => (
              <DashboardCard key={idx} loading={true} />
            ))
          ) : (
            data.cardData.map((card) => (
              <DashboardCard key={card.id} title={card.title} content={card.content} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
